<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">
    <div class="hpanel no-margins" >
      <template v-if="news.length !== 0">

        <div class="panel-heading hbuilt">

          <div class="row">
            <div class="col-xs-6 text-center">
              Best News: <span class="font-extra-bold m-t-xl m-b-xs text-info" >{{bestNews}}</span>
            </div>
            <div class="col-xs-6 text-center">
              Total News estimate: <span class="font-extra-bold m-t-xl m-b-xs" style="">{{nbEstimateNews}}</span>
            </div>
          </div>
        </div>

        <div class="panel-body no-padding ">
          <table style="width: 100%">
            <tr style="height: 25px">

              <th class="col-xs-5 col-md-5" style="vertical-align: middle">
                <span role="button" @click="changeSort('title')">Title <i style="padding-left: 15px" class="fa fa-sort"></i></span>
              </th>
              <th class="col-xs-3 col-md-3 text-center" style="vertical-align: middle">
                <span role="button" @click="changeSort('provider')">Provider <i style="padding-left: 15px" class="fa fa-sort"></i></span>
              </th>
              <th class="col-xs-2 col-md-2 text-center" style="vertical-align: middle">
                <span role="button" @click="changeSort('date')">Date <i style="padding-left: 15px" class="fa fa-sort"></i></span>
              </th>

              <th class="col-xs-1 col-md-1 text-center" style="vertical-align: middle">
                <span role="button" @click="changeSort('score')">Score <i style="padding-left: 15px" class="fa fa-sort"></i></span>
              </th>
              <th class="col-md-1 col-xs-1 text-center"><span>Action</span></th>
            </tr>
          </table>
          <div v-if="news.length !== 0" >
            <div v-for="(item, key) in news" v-if="news && key < context.nbItemsDisplay" :key="'news-'+key" class="clearfix ">
                <news-top v-model="news[key]" class="" :context="context" :key="'news-'+key"/>
                <div class="col-xs-12 collapse" :id="'collapse-'+ item.id" style="padding: 20px" >
                  <document-news v-model="news[key]" :news="item"
                                     :pubDateSelected="context.pubDateSelected" :context="context" :biblioBoxes="biblioBoxes"/>
                </div>
            </div>

            <div class="text-center" style="padding: 25px" v-if="news.length > context.nbItemsDisplay">
              <button class="btn btn-primary btn-xs" :class="news.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="news.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import NewsTop from '../documents/NewsTop'
import DocumentNews from '../documents/DocumentNews'

export default {
  components: {
    DocumentNews,
    NewsTop
  },
  props: ['context', 'value', 'nbEstimateNews', 'nbNews', 'listType', 'changeSort', 'biblioBoxes'],
  name: 'ListNewsResults',
  watch: {
    value: function (val) {
      this.news = val
    }
  },
  data () {
    return {
      news: null
    }
  },
  computed: {
    bestNews: function () {
      return this.nbNews
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })
  },
  beforeMount () {
    this.news = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListNews/ListNewsResults.vue